import axios from "axios";
import { UploadImportFileRequest } from "../../../types/interfaces/file/imports";
import { UploadMonitoringRecordsResponse } from "../../../types/interfaces/file/imports/monitoringRecords";
import { SessionStore } from "../../../types/store/SessionStore";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures`;

export const uploadMonitoringRecordsFile = async (
  captureId: number,
  uploadInfo: UploadImportFileRequest,
): Promise<UploadMonitoringRecordsResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const formData = new FormData();
  formData.append("monitoringXLSX", uploadInfo.file);

  const res = await axios.post<UploadMonitoringRecordsResponse>(
    `${BASE_URL}/${captureId}/monitoring/upload/validate`,
    formData,
    {
      headers: {
        "content-type": "multipart/form-data",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
